import { CSSProperties, useContext, useMemo, useState } from "react";

import CloseIcon from "~/icons/CloseIcon";
import ThemeContext from "~/contexts/ThemeContext";

import styles from "./InfoBar.module.css";
import { getButtonStyles } from "~/theme/models/themeModels";
import { Size } from "~/entities/templateEntities";
import AuthContext from "~/contexts/AuthContext";
import LoyaltyBalance from "~/modules/loyalty/components/LoyaltyBalance/LoyaltyBalance";
import SiteContext from "~/contexts/SiteContext";
import { appConfig } from "~/configs/appConfig";

const InfoBar: React.FC = () => {
  const [hideAuthSection, setHideAuthSection] = useState(false);

  const { template } = useContext(ThemeContext);
  const { authenticatedUser, isAuthEnabled, useComoAuth, setIsAuthDialogOpen } =
    useContext(AuthContext);
  const { site } = useContext(SiteContext);

  const loyaltyBalance = authenticatedUser?.loyaltyBalance;

  // Styles
  const menuBackgroundColor = template.menuScreen.general.backgroundColour;
  // Texts
  const loginOrSignUp = template.loyalty.text.loginOrSignUp;

  const backgroundColor = template.infoBar.general.backgroundColour;
  const color = template.infoBar.general.fontColour;

  const buttonStyles: CSSProperties | undefined = useMemo(() => {
    const baseStyles = getButtonStyles(
      template.infoBar.authButton.colour,
      template.infoBar.authButton.colour,
      template.infoBar.authButton.fontColour,
      Size.S,
      template.infoBar.authButton.style,
    );
    const hoverStyles = {
      "--hover-auth-button-colour": template.infoBar.authButton.hoverColour,
      "--hover-auth-button-border-colour":
        template.infoBar.authButton.hoverColour,
      "--hover-auth-button-font-colour":
        template.infoBar.authButton.hoverFontColour,
    };

    return {
      ...baseStyles,
      ...hoverStyles,
    };
  }, [
    template.infoBar.authButton.colour,
    template.infoBar.authButton.fontColour,
    template.infoBar.authButton.hoverColour,
    template.infoBar.authButton.hoverFontColour,
    template.infoBar.authButton.style,
  ]);

  return (
    site && (
      <>
        {/* Desktop Info Bar — store / fulfilment / ETA / "Change" row removed
            (now shown by the persistent StoreHeader bar). Only the auth /
            loyalty content remains, so the bar collapses without it. */}
        {isAuthEnabled && (
          <div
            className={styles.desktopWrapper}
            style={{
              backgroundColor,
              color,
            }}
          >
            <div className={styles.desktopInnerWrapper}>
              <div className={styles.loyalty}>
                {!authenticatedUser ? (
                  !appConfig.WebView && (
                    <div
                      className={styles.authButton}
                      style={buttonStyles}
                      onClick={() => setIsAuthDialogOpen(true)}
                    >
                      {loginOrSignUp}
                    </div>
                  )
                ) : (
                  <LoyaltyBalance fontColor={color} />
                )}
              </div>
            </div>
          </div>
        )}
        {/* Mobile Info Bar */}
        <div
          className={styles.mobileWrapper}
          style={{
            backgroundColor: menuBackgroundColor,
          }}
        >
          {/* Store / fulfilment / ETA / "Change" section removed — now shown
              by the persistent StoreHeader bar to avoid duplication. */}
          {isAuthEnabled &&
            useComoAuth &&
            !hideAuthSection &&
            (authenticatedUser || !appConfig.WebView) && (
              <div
                className={styles.mobileSection}
                style={{ backgroundColor, color }}
              >
                <div className={styles.mobileAuthLabel}>
                  {authenticatedUser ? (
                    <LoyaltyBalance fontColor={color} />
                  ) : (
                    <span
                      className={styles.mobileAuthLink}
                      onClick={() => setIsAuthDialogOpen(true)}
                    >
                      {loginOrSignUp}
                    </span>
                  )}
                </div>
                {loyaltyBalance == undefined && (
                  <div
                    className={styles.mobileCloseIconWrapper}
                    onClick={() => setHideAuthSection(true)}
                  >
                    <CloseIcon />
                  </div>
                )}
              </div>
            )}
        </div>
      </>
    )
  );
};

export default InfoBar;
